<template>

    <div class="col">
        <p class="step-caption ft-bld">Configure your automated row</p>

        <InputWrapper placeholder="Row name" :max-chars="18" v-model="Global.newRowOverlay.name"></InputWrapper>
        <SelectOptsWrapper class="mre-z" caption="Display" :opts="['Most viewed','Continue Watching','Best rated']" v-model="Global.newRowOverlay.content"></SelectOptsWrapper>
        <SliderWrapper caption="Number of contents in row" :range-min="5" :range-max="45" v-model="Global.newRowOverlay.assetsCount"></SliderWrapper>
        <SelectOptsWrapper caption="Place this row" :opts="displayAfterList" v-model="displayAfter"></SelectOptsWrapper>

        <div class="nxt-out">
            <div class="btn bck" @click.prevent="switchStep('prv')" :style="Global.rowIdToEdit ? {opacity: 0, pointerEvents: 'none'} : null">
                <span class="txt">Back</span>
            </div>
            <div class="btn main txt-blk" @click.prevent="submit">
                <span class="hvr"></span>
                <span class="txt">Validate</span>
            </div>
        </div>
    </div>

</template>

<script>

    import Global from '../../lib/GlobalState'
    import InputWrapper from '../../components/InputWrapper'
    import SelectOptsWrapper from '../../components/SelectOptsWrapper'
    import SliderWrapper from '../../components/SliderWrapper'

    export default {

        name: 'NewRowTwoAuto',

        components: {
            InputWrapper,
            SelectOptsWrapper,
            SliderWrapper
        },

        data() {
            return {
                Global,
                displayAfter: "In first position"
            }
        },

        computed: {
            displayAfterList() {

                const names = []
                names.push("In first position")

                let rows = Object.assign([], this.Global.rows)

                if(this.Global.rowIdToEdit) {
                    rows = rows.filter((row) => {
                        return row.id != this.Global.rowIdToEdit
                    })
                }

                rows.map((row) => {
                    names.push("After " + row.name)
                })

                return names
            }
        },

        mounted() {

            if(this.Global.rowIdToEdit) {
                const index = this.Global.rows.findIndex((row) => {
                    return row.id == this.Global.rowIdToEdit
                })

                this.displayAfter = this.displayAfterList[index]
            } else {
                this.displayAfter = this.displayAfterList[this.displayAfterList.length-1]
            }
        },

        methods: {

            switchStep(dir) {
                this.$emit(dir)
            },

            submit() {
                if(this.Global.rowIdToEdit) {
                    this.submitEdit()
                } else {
                    this.submitAdd()
                }
            },

            async submitAdd() {
                const row = Object.assign({}, this.Global.newRowOverlay)
                const assets = Object.assign([], this.Global.assets).map((asset, index) => {
                    asset.index = index
                    return asset
                })

                row.id = Date.now()
                row.assets = this.getRandomAssets(assets, row.assetsCount).map((asset) => {
                    return asset.index
                })

                const newIndex = this.displayAfterList.findIndex((name) => {
                    return name === this.displayAfter
                })
                
                await this.$parent.closeRowOverlay()
                this.Global.rows.splice(newIndex,0,row)
            },

            async submitEdit() {
                const oldRow = this.Global.rows.find((row) => {
                    return row.id == this.Global.rowIdToEdit
                })
                const row = Object.assign({}, this.Global.newRowOverlay)
                const assets = this.Global.assets.map((asset, index) => {
                    asset.index = index
                    return asset
                })

                if(row.assets.length != row.assetsCount || oldRow.content != row.content) {
                    row.assets = this.getRandomAssets(assets, row.assetsCount).map((asset) => {
                        return asset.index
                    })
                }

                const index = this.Global.rows.findIndex((row) => {
                    return row.id == this.Global.rowIdToEdit
                })
                
                const newIndex = this.displayAfterList.findIndex((name) => {
                    return name === this.displayAfter
                })
                
                await this.$parent.closeRowOverlay()
                this.Global.rows.splice(index,1)
                this.Global.rows.splice(newIndex,0,row)
            },

            getRandomAssets(arr, num) {
                let result = new Array()
                
                while(result.length < num) {
                    const shuffled = [...arr].sort(() => 0.5 - Math.random());
                    result = result.concat(shuffled)
                }

                return result.slice(0,num)
            }
        }
    }

</script>